import { render, staticRenderFns } from "./BookingDirection.vue?vue&type=template&id=50b93218"
import script from "./BookingDirection.vue?vue&type=script&lang=js"
export * from "./BookingDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports